import * as React from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { ProjectConfig } from 'Global';
import Cookies from 'universal-cookie';
import { List } from 'devextreme-react';
import { Button, Dialog, LinearProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import EmptyElement from './EmptyElement';

import { ApiRequest } from 'GlobalFunctions';

const cookies = new Cookies();

interface IAutocompleteList {
  name: string;
  id: number;
}



export default function AutocompleteSuppliers(props: any) {

  const company_id = cookies.get('company_id');

  const {value, onChange, error} = props;
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const handleOpenList = () => {
  setOpen(true);
  };


  const [openEditor, setOpEditor] = useState(false);

  const [productName, setProductName] = useState("");

  /*=================================================
    CLIENT AUTOCOMPLETE VARIABLES & FUNCTIONS
    =================================================*/
    interface IProjectList {
      inputValue?: string,
      supplier_id?: number,
      supplier_name: string,
    };
    const filter = createFilterOptions<IProjectList>();

    //setClientList
    const [list, setList] = useState<any []>([]);
    const [parent_product, setParentProduct] = useState<IProjectList | null>(null);
    
    useEffect(() => {
      getSupplierList();
    }, []);
    /* ================================================= 
    ===================================================*/


    const getSupplierList = async () => {

      await ApiRequest({
        url: "/suppliers/list",
        method: "get",
        headers: {
          ltkn: localStorage.getItem("ltkn"),
        },
        query: {
          full_list: true,
        },
        setResponse: (response: any) => {
          setList(response.list);
          setLoading(false);
        },
      });
    }


    let item_name = "";
    if (list && (value && value!=0)) 
    {
      item_name = list.find(obj => {
        return obj.supplier_id === parseInt(value); 
      })
    } 
    
    
  return (
    <>

     {list.length > 0 ? 
     (
      <Autocomplete
        value={item_name}
        onChange={(event, newValue) => {
          if (typeof newValue === 'string') {
            setParentProduct({
              supplier_name: newValue,
            });
          } else if (newValue && newValue.inputValue) {
            console.log("newValue", newValue);
            setParentProduct({
              supplier_name: newValue.inputValue,
              supplier_id: 0,
            });

            setProductName(newValue.inputValue);
            setOpEditor(true);
            

          } else {
            setParentProduct(newValue);
            if (newValue?.supplier_id!=null)
            {
              onChange({
                  target: {
                      value: newValue.supplier_id.toString(),
                      name: "supplier_id",
                  }
              })
            }
            else {
              onChange({
                target: {
                    value: "",
                    name: "supplier_id",
                }
              })
            }
            
          }
          
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          const { inputValue } = params;
          // Suggest the creation of a new value
          const isExisting = options.some((option) => inputValue === option.supplier_name);
          if (inputValue !== '' && !isExisting) {
            filtered.push({
              inputValue,
              supplier_name: `Agregar "${inputValue}"`,
              
            });
          }

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        fullWidth
        id="free-solo-with-text-demo"
        options={list}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.supplier_name;
        }}
        renderOption={(props, option) => <li className="flex_select" {...props}>
          <div className="flex_option_1">{option.supplier_name}</div>
        </li>}
        freeSolo
        renderInput={(params) => (
          <TextField 
          {...params} 
          label="Proveedor" 
          error={error}
          
          placeholder='Proveedor'
          />
        )}
        
      /> 
      )
      :
      (
        <>
        
        <LinearProgress />
        
        </>
      )}


    </>
  );
}
